import { Text, View, Image } from 'components';
import { Modal } from 'components/Modal';
// import Modal from 'react-modal';
import Base, { Config } from 'components/megatron/Base';
import React from 'react';
import cx from 'classnames';
import styles from './index.module.scss';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


interface Props {
  data: any 
  from?: string
  cssClass?: string
  type?: 'top' | 'mine'
}


export default class WorkItem extends Base<Props> {
  

  public didMount(){
    
  }

  public render() {
    const { data, type } = this.props;

    if (!data) return '';
    let salary_txt = data.salary;
    if (data.salary == 0 || !data.salary) {
      salary_txt = '面议';
    } else if (data.salary == 12000) {
      salary_txt = '12000以上';
    }

    return (
      <View className={cx(styles.container, {
        [styles.topMode]: type == 'top',
      })}>
        <View className={cx(styles.item , 'css-class')} onClick={this.goToDetail}>
          <View className={styles.inner}>
            
            {data.state == 3 && 
              <View className={styles.found}>
                {type=='mine'? 
                  <Image className={styles.img2} src={this.assets.megatron.foundMine} /> :
                  <Image className={styles.img} src={this.assets.megatron.found} />
                }
              </View>
            }

            {data.state == 2 && 
              <View className={styles.found}><Image className={styles.img1} src={this.assets.megatron.employAuditing} /></View>
            }
            
            <View className={styles.top}>
              {data.alias && 
                <Text className={cx(styles.tp, {
                  [styles.cc]: data.alias == '铲车'
                })}>{data.alias}</Text>
              }
              <Text className={styles.tit}>{data.address || '全国'}</Text>
              
              

              <View className={styles.price}>
                <View className={styles.relativeBox}>
                  {salary_txt != '面议'? salary_txt+'/月' : salary_txt}
                </View>
              </View>
            </View>
            <View className={styles.mid}>
              <Text className={styles.p}>{data.description || '暂无描述'}</Text>
              
            </View>
            <View className={styles.bottom}>
              <View className={styles.bl}>
                {Array.isArray(data.skills) &&
                  data.skills.map((skill, idx) => {
                    return (
                      <Text key={idx} className={cx(
                        styles.skills,
                        idx == data.skills.length - 1 ? styles.last : ''
                      )}>
                        {skill}
                      </Text>
                    );
                  })}
                {data.excellent && <Text className={styles.high}>高工资</Text>}
                <View className={styles.tags}>
                  {Array.isArray(data.specials) &&
                    data.specials.map((s, idx) => {
                      return (
                        <Text key={idx} className={styles.tag}>{s}</Text>
                      );
                  })}
                </View>
              </View>
              <View className={styles.br}>
                <Text className={styles.time}>{data.ctime || ''}</Text>
              </View>
            </View>
          </View>
        </View>

      </View>
    );
  }

  private goToDetail = () => {
    
  }
  
}
